import { render, staticRenderFns } from "./MarkupList.vue?vue&type=template&id=4aa91660&scoped=true"
import script from "./MarkupList.vue?vue&type=script&lang=js"
export * from "./MarkupList.vue?vue&type=script&lang=js"
import style0 from "./MarkupList.vue?vue&type=style&index=0&id=4aa91660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa91660",
  null
  
)

export default component.exports